import React from 'react'
import './AvatarView.css'

const AvatarViewUI = ({context, messageList, avatarUrl}) =>
  <div className='usr_avtr_v g_flex_h'>
    <img src={avatarUrl} alt='' />
  </div>

export default AvatarViewUI
